import React, {useState} from 'react'

export default function ChampFormulaireInscription(props) {
    return <label>
                <br /> <input type="password" className="center-moyen inputChamp" id={props.id} name={props.champ} onChange={props.handleChange} placeholder={props.champ} />
            </label>
            
  }